import dayjs from "dayjs";

export const REPORT_EXPORT_FORMATS = ["csv", "xlsx", "pdf"];

// Export config for report endpoints that take ?format=. RegisterLayoutHandler
// appends the chosen format to the file name.
export const reportExport = (
  api: string,
  name: string,
  formats: string[] = REPORT_EXPORT_FORMATS,
) => ({
  api,
  fileName: `${name}_${new Date().toISOString().split("T")[0]}`,
  formats,
});

const MONTHS = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  name: dayjs().month(i).format("MMMM"),
}));

const QUARTERS = [1, 2, 3, 4].map((quarter) => ({
  id: quarter,
  name: `Q${quarter}`,
}));

const recentYears = (count = 5) =>
  Array.from({ length: count }, (_, i) => {
    const year = dayjs().year() - i;
    return { id: year, name: String(year) };
  });

// Period params shared by the wage report endpoints
export const wagePeriodFilters = [
  {
    id: "year",
    name: "year",
    type: "select",
    selectOptions: recentYears(),
  },
  {
    id: "quarter",
    name: "quarter",
    type: "select",
    selectOptions: QUARTERS,
  },
  {
    id: "month",
    name: "month",
    type: "select",
    selectOptions: MONTHS,
  },
  {
    id: "period",
    name: "period",
    header: "Date Range",
    type: "date",
    dateRangeNames: { startDateKey: "start_date", endDateKey: "end_date" },
  },
];
